import request from '../request';

let storedCategories = [];
if (localStorage.getItem('categories') !== null) {
  storedCategories = JSON.parse(localStorage.getItem('categories'));
}

export default {
  state: {
    data: storedCategories,
  },
  mutations: {
    setCategories(state, categories) {
      Object.assign(state, { data: categories });
    },
  },
  actions: {
    getCategories(context) {
      request.make({
        type: 'GET',
        url: `${process.env.API_URL}category?include=groups`,
      }, (err, res) => {
        if (!err) {
          if (res.status === 200) {
            context.commit('setCategories', res.body.data);
            context.dispatch('setActivityCategories', res.body.data);
            localStorage.setItem('categories', JSON.stringify(res.body.data));
          }
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/categories.js